import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { message } from "antd";
import { useMutation } from "react-query";
import dayjs from "dayjs";
import trainingService from "../../../logic/useTrainingCardListService";
import coursesService from "../../../../CardList/logic/useCardListService";
import { useQuery } from "react-query";
import useTrainingCardList from "../../../logic/useTrainingCardList";

const useTrainingEditLogic = (
  sessionData,
  handleCancel,
  setCurrentStep,
  idTraining,
  setData,
  selectedDates,
  isUpcomingTraining,
  isModalEditOpen
) => {

  const customDateFormat = 'YYYY-MM-DD';

  const {
    control,
    formState: { errors },
    reset,
    watch,
    handleSubmit,
    setValue,
  } = useForm();
  const { data: filtredUsersData } = useQuery("filterUsers", () =>
    trainingService.filterUsersByRole(["Trainer"]),
    {
      enabled: isModalEditOpen,
    }
  );

  const { data: courseData } = useQuery("allCourses", () =>
    coursesService.getCoursesData("", undefined, undefined),
    {
      enabled: isModalEditOpen,
    }
  );

  const selectedUsers = filtredUsersData?.data
    ? filtredUsersData?.data?.map((user) => ({
        value: user.id,
        label: user.firstName + " " + user.lastName,
      }))
    : [];

  const courseOptions = courseData?.data.data
    ? courseData?.data?.data?.map((course) => ({
        value: course.id,
        label: course.title,
      }))
    : [];

  const [selectedOptionLanguage, setSelectedOptionLanguage] = useState([
    {
      value: "english",
      label: "English",
    },
    {
      value: "french",
      label: "French",
    },
    {
      value: "spanish",
      label: "Japanese",
    },
  ]);

  const { refetchTraining } = useTrainingCardList(isUpcomingTraining);

  const {
    data: dataTrainingDetails,
    isLoading: isLoadingTrainingDetails,
    error: errorTrainingDetails,
    refetch: refetchTrainingDetails,
  } = useQuery(["trainingDetailsData", idTraining], () =>
  trainingService.getTrainingById(idTraining),
  {
      enabled: isModalEditOpen,
  }
  );

  useEffect(() => {
    if (dataTrainingDetails?.data) {
      setValue("trainer", {
        value: dataTrainingDetails?.data?.trainer?.id,
        label: dataTrainingDetails?.data?.trainer?.firstName,
      });
      setValue("course", {
        value: dataTrainingDetails?.data?.course?.id,
        label: dataTrainingDetails?.data?.course?.title,
      });
      setValue("language", dataTrainingDetails?.data?.language);
      setValue("location", dataTrainingDetails?.data?.location);
      setValue("isGuaranteed", dataTrainingDetails?.data?.isGuaranteed);
      setValue("equipment", dataTrainingDetails?.data?.neededEquipment);

      const startDateDayjs = dataTrainingDetails?.data?.start_date
        ? dayjs(dataTrainingDetails?.data?.start_date)
        : null;
      const endDateDayjs = dataTrainingDetails?.data?.end_date
        ? dayjs(dataTrainingDetails?.data?.end_date)
        : null;

      setValue("rangeDate", [startDateDayjs, endDateDayjs]);
    }
  }, [dataTrainingDetails?.data, setValue]);

  useEffect(() => {

    if (dataTrainingDetails?.data?.sessionsGroupedByDate){
      const newData = {};
      if (selectedDates.length > 0) {
        selectedDates.forEach((date) => {
          const sessionsOnDate = dataTrainingDetails?.data?.sessionsGroupedByDate[date];
          if (sessionsOnDate) {
            sessionsOnDate.flat().forEach((session, index) => {
              const from = session.from
                ? dayjs(`${date} ${session.from}`, `${customDateFormat} h:mm a`)
                : null;
              const to = session.to
                ? dayjs(`${date} ${session.to}`, `${customDateFormat} h:mm a`)
                : null;
              const fieldName = `time_${date}_${index}`;
              setValue(fieldName, [from, to]);
            });
          }

          newData[date] =
          dataTrainingDetails?.data?.sessionsGroupedByDate[date] || [];
        if (newData[date].length === 0) {
          newData[date].push({
            date,
            from: null,
            to: null,
          });
        }
        });
        setData(newData);
      }
    }
  }, [selectedDates, dataTrainingDetails?.data?.sessionsGroupedByDate, setData, setValue]);

  const updateTrainingMutation = useMutation(
    (formData) =>
      trainingService.updateTraining(dataTrainingDetails.data.id, formData),
    {
      onSuccess: () => {
        refetchTrainingDetails();
        refetchTraining();
        handleCancel();
        setCurrentStep(0);
        message.success("Training updated successfully");
      },
      onError: (error) => {
        console.error("Error updating training:", error);
        message.error("Failed to update training");
      },
    }
  );

  const onUpdateTraining = () => {
    const flattenedSessionData = Object.values(sessionData).flat();
    const modifiedSessionData = flattenedSessionData.map((session) => {
      const { key, createdAt, ...rest } = session;
      return rest;
    });
    const intermediateStartDate = dayjs(watch("rangeDate")[0]).unix();
    const intermediateEndDate = dayjs(watch("rangeDate")[1]).unix();
    const formData = {
      start_date: dayjs.unix(intermediateStartDate).format("YYYY-MM-DD"),
      end_date: dayjs.unix(intermediateEndDate).format("YYYY-MM-DD"),
      neededEquipment: watch("equipment"),
      isGuaranteed: watch("isGuaranteed"),
      language: watch("language"),
      location: watch("location"),
      courseId: watch("course").value || watch("course"),
      trainerId: watch("trainer").value || watch("trainer"),
      sessions: modifiedSessionData,
    };
    const trainingId = dataTrainingDetails.data.id;
    updateTrainingMutation.mutate(formData);
  };

  return {
    control,
    errors,
    reset,
    watch,
    handleSubmit,
    setValue,
    selectedUsers,
    courseOptions,
    selectedOptionLanguage,
    setSelectedOptionLanguage,
    dataTraining: dataTrainingDetails?.data,
    isLoadingTrainingDetails,
    errorTrainingDetails,
    refetchTrainingDetails,
    onUpdateTraining,
    customDateFormat
  };
};

export default useTrainingEditLogic;
